import { render, staticRenderFns } from "./customTab.vue?vue&type=template&id=72152f2b"
import script from "./customTab.vue?vue&type=script&lang=js"
export * from "./customTab.vue?vue&type=script&lang=js"
import style0 from "./customTab.vue?vue&type=style&index=0&id=72152f2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports